module.exports = __webpack_public_path__ + "img/xiaochengxuCode.c8b0ea89.jpg";